import React from 'react';

const VerifyEmailIcon = () => {
  return (
    <svg
      width="76"
      height="62"
      viewBox="0 0 76 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72.8331 53L48.4761 31M27.5237 31L3.16671 53M1.33325 12.6666L31.2713 33.6232C33.6956 35.3203 34.9077 36.1688 36.2262 36.4974C37.3909 36.7877 38.609 36.7877 39.7736 36.4974C41.0921 36.1688 42.3043 35.3203 44.7285 33.6233L74.6666 12.6666M18.9333 60.3333H57.0666C63.2272 60.3333 66.3074 60.3333 68.6605 59.1344C70.7303 58.0798 72.413 56.397 73.4677 54.3272C74.6666 51.9742 74.6666 48.8939 74.6666 42.7333V19.2666C74.6666 13.106 74.6666 10.0258 73.4677 7.67273C72.413 5.60295 70.7303 3.92016 68.6605 2.86555C66.3074 1.66663 63.2272 1.66663 57.0666 1.66663H18.9333C12.7727 1.66663 9.69239 1.66663 7.33936 2.86555C5.26957 3.92016 3.58679 5.60295 2.53218 7.67273C1.33325 10.0258 1.33325 13.106 1.33325 19.2666V42.7333C1.33325 48.8939 1.33325 51.9742 2.53218 54.3272C3.58679 56.397 5.26957 58.0798 7.33936 59.1344C9.69239 60.3333 12.7727 60.3333 18.9333 60.3333Z"
        stroke="#06AED4"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VerifyEmailIcon;
